import { schema } from "normalizr";

const EmployeeContactSchema = new schema.Entity("employeeContacts");
const EmployeeContactArraySchema = new schema.Array(EmployeeContactSchema);

export { EmployeeContactSchema, EmployeeContactArraySchema };